// init.ts used to initialize Labs domain components on startup.

import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { sharedItemProviderFactory } from "@/Portal/Services/SharedItemProviderFactory";
import { LabRequestSharedItemProvider } from "./Services/Portal/LabRequestSharedItemProvider";
import { LabResultSharedItemProvider } from "./Services/Portal/LabResultSharedItemProvider";

sharedItemProviderFactory.registerProvider(PortalLinkedItemType.LabRequest, new LabRequestSharedItemProvider());
sharedItemProviderFactory.registerProvider(PortalLinkedItemType.Result, new LabResultSharedItemProvider());
